export default "__VITE_PUBLIC_ASSET__0ce2c8ea__"